import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import CustomContainer from '../../components/common/CustomContainer'
import { useNavigate } from 'react-router-dom'
import styles from "../../assets/styles/labtest.module.css"
import { useDownloadExcel } from 'react-export-table-to-excel';
import { getAmbulanceUtilizationListApi } from '../../utils/api/services'
import { toast } from 'react-toastify'
import moment from 'moment'
import AmbulanceUtilizationTable from '../../components/ambulance/AmbulanceUtilizationTable';

const AmbulanceUtilization = () => {
    const [searchValue, setSearchValue] = useState('')
    const [filterValue, setFilterValue] = useState<FilterTypes>({
        fromDate: null,
        toDate: null
    })
    const [loading, setLoading] = useState(false)
    const [listData, setListData] = useState<AmbUtilizationItemTypes[] | []>([])
    const navigate = useNavigate();
    const tableRef = useRef<HTMLTableElement>(null);
    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: 'Ambulance Utilization',
        sheet: 'list'
    })

    const handleDateChange = (value: Date | null, name: string) => {
        const momentValue = value !== null ? moment(value)?.format('DD-MM-YYYY') : null;
        setFilterValue({
            ...filterValue,
            [name]: momentValue
        })
    }
    const handleSearchValue = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value)
    }
    const fetchListData = async (data?: { searchQuery?: string, fromDate?: Date | null, toDate: Date | null }) => {
        try {
            setLoading(true)
            const result = await getAmbulanceUtilizationListApi(data);
            if (result?.success) {
                setLoading(false)
                setListData(result?.utilizationList)
            }
            else {
                setLoading(false)
                setListData([])
            }
        } catch (error: any) {
            setLoading(false)
            toast.error(error?.data?.errors || error?.message);
        }
    }

    useEffect(() => {
        if (searchValue) {
            const cleanUpFun = setTimeout(() => {
                fetchListData({ searchQuery: searchValue, fromDate: filterValue?.fromDate, toDate: filterValue?.toDate })
            }, 1000);
            return () => clearInterval(cleanUpFun)
        }
        else {
            fetchListData({ searchQuery: searchValue ? searchValue : undefined, fromDate: filterValue?.fromDate, toDate: filterValue?.toDate })
        }
    }, [searchValue, filterValue]);

    return (
        <CustomContainer>
            <div className='AllPageMain'>
                <div className='HeadAndButton'>
                    <h2>Ambulance Utilization</h2>
                    <div className='flex items-center gap-6'>
                        <button className='fillButton' onClick={() => navigate('/ambulance/utilization/add')}>New Entry +</button>
                        <button className='outLineBtn' onClick={onDownload}>Export Data</button>
                    </div>
                </div>
                <div className={styles.labTestMain}>
                    <AmbulanceUtilizationTable
                        listData={listData}
                        loading={loading}
                        searchValue={searchValue}
                        ref={tableRef}
                        handleSearchValue={handleSearchValue}
                        filterValue={filterValue}
                        handleDateChange={handleDateChange}
                    />
                </div>
            </div>
        </CustomContainer>
    )
}

export default AmbulanceUtilization